import React, { useMemo } from 'react';

import { ReactComponent as OriginMarker } from './origin-marker.svg';
import { ReactComponent as DestinationMarker } from './destination-marker.svg';
import { ReactComponent as UploadIcon } from './upload-icon.svg';
import { ReactComponent as CheckIcon } from './check-icon.svg';

const images = {
  OriginMarker,
  DestinationMarker,
  UploadIcon,
  CheckIcon,
};

const Image = ({ type, color, strokeColor, text, onClick }) => {
  const SVG = useMemo(() => {
    const SVGComponent = images[type];
    if (!SVGComponent) return null;

    // Only apply fill color if explicitly provided (for icons that need color control)
    // Markers with hardcoded colors should not have fill overridden
    const style = {};
    if (color) {
      style.fill = color;
      style.color = color; // For currentColor to work
    }

    if (strokeColor) {
      style.stroke = strokeColor;
    }

    // Only pass fill prop if color is provided
    return <SVGComponent style={Object.keys(style).length > 0 ? style : undefined} fill={color || undefined} />;
  }, [type, color, strokeColor]);

  return (
    <div className={`img-${type}`} style={color ? { color } : undefined} onClick={onClick}>
      {SVG}
      {text !== undefined && <span>{text}</span>}
    </div>
  );
};

export default React.memo(Image);
